import { useFeatureFlag } from '@fs/zion-flags'
import React, { useCallback } from 'react'
import isEqual from 'lodash.isequal'
import useSearchResultsColumns from './searchResultsColumns'

/**
 * Return available columns after filtering out those without their corresponding feature flag
 * enabled.
 * @param {String} columnConfig e.g. 'global', 'jiapu', 'jokbo'
 * @returns filtered columns (removes those without their corresponding feature flag enabled)
 */
export default function useColumns(columnConfig) {
  const indexedPercentageFlag = useFeatureFlag('lightyear_sharedImageViewer_indexedPercentage')
  const columns = useSearchResultsColumns()
  const getFilteredColumns = useCallback(() => {
    return columns[columnConfig]?.filter((column) => {
      if (column.id === 'imagesIndexed' && !indexedPercentageFlag?.isOn) {
        return false
      }
      return true
    })
  }, [columnConfig, columns, indexedPercentageFlag?.isOn])

  const [filteredColumns, setFilteredColumns] = React.useState(() => getFilteredColumns())

  React.useEffect(() => {
    const newFilteredColumns = getFilteredColumns()
    if (!isEqual(newFilteredColumns, filteredColumns) && Array.isArray(newFilteredColumns)) {
      setFilteredColumns(newFilteredColumns)
    }
  }, [filteredColumns, getFilteredColumns])

  return filteredColumns
}
